import styled from "styled-components";

export default styled.div`
    margin: 40px 20px 20px 20px;
    min-height: 300px;
    text-align: center;
    
    img {
        width: 100px;
        height: 100px;
        display: inline-block;
        border-radius: 5px;
    }
`;